import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialButton from "../../../../components/MaterialButton";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  CardHeader,
  Stack,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { BsFillPersonVcardFill } from "react-icons/bs";
import MaterialTypography from "../../../../components/MaterialTypography";

function RealtimeInventoryView() {
  const navigate = useNavigate();
  const location = useLocation();
  const data = location?.state?.data;

  return (
    <DashboardLayout>
      <Card sx={{ minHeight: "90vh" }}>
        <CardContent>
          <Stack
            direction="row"
            spacing={1}
            sx={{ display: "flex", alignItems: "center" }}
          >
            <BsFillPersonVcardFill style={{ fontSize: 20 }} />
            <MaterialTypography
              component="label"
              variant="body2"
              fontWeight="bold"
            >
              Realtime Inventory View
            </MaterialTypography>
          </Stack>
          <div>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: 2,
              }}
            >
              <Card
                sx={{
                  maxWidth: 700,
                  width: "100%",
                  borderRadius: 3,
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                  background: "linear-gradient(135deg, #ffffff, #f8f9fa)",
                }}
              >
                <CardHeader
                  title={
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      spacing={2}
                    >
                      <Stack direction="column" spacing={0}>
                        <MaterialTypography variant="h5" fontWeight="medium">
                          Realtime Inventory
                        </MaterialTypography>
                      </Stack>
                    </Stack>
                  }
                />
                <CardContent>
                  <Grid container>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <MaterialTypography variant="subtitle1" fontWeight="bold">
                      Product Details
                    </MaterialTypography>
                    <MaterialTypography fontSize="16px" color="textSecondary">
                      <strong>Product Name:</strong> {data.productName}
                    </MaterialTypography>
                    <MaterialTypography fontSize="16px" color="textSecondary">
                      <strong>Code:</strong> {data.productCode}
                    </MaterialTypography>
                    <MaterialTypography fontSize="16px" color="textSecondary">
                      <strong>Brand:</strong> {data.productCategory}
                    </MaterialTypography>
                    <MaterialTypography fontSize="16px" color="textSecondary">
                      <strong>Category:</strong> {data.productBrand}
                    </MaterialTypography>
                  </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                      <Box mt={2}>
                        <MaterialTypography
                          variant="subtitle1"
                          fontWeight="bold"
                        >
                          Stock Details
                        </MaterialTypography>
                        <MaterialTypography
                          fontSize="16px"
                          color="textSecondary"
                        >
                          <strong>Original Stock:</strong> {data.originalStock}{" "}
                          {data.productUom}
                        </MaterialTypography>
                        <MaterialTypography
                          fontSize="16px"
                          color="textSecondary"
                        >
                          <strong>Current Stock:</strong> {data.currentStock}{" "}
                          {data.productUom}
                        </MaterialTypography>
                        {/* <MaterialTypography
                          fontSize="16px"
                          color="textSecondary"
                        >
                          <strong>Balance Stock:</strong> {data.balanceStock}{" "}
                          {data.productUom}
                        </MaterialTypography> */}
                      </Box>
                    </Grid>
                  </Grid>
                </CardContent>
                <MaterialBox
                  display="flex"
                  justifyContent="flex-end"
                  alignItems="center"
                >
                  <MaterialButton
                    sx={{ m: 2 }}
                    variant="gradient"
                    color="dark"
                    onClick={() => navigate("/realtime-inventory")}
                  >
                    Back
                  </MaterialButton>
                </MaterialBox>
              </Card>
            </Box>
          </div>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
}

export default RealtimeInventoryView;
